import { useInfiniteQuery } from '@tanstack/react-query'
import { useState } from 'react'
import styled from 'styled-components'

import { QUERY_KEY } from '../../constants'

import { getUserProductSoldList } from '../../api/my'
import type { GetUserProductSoldListParams } from '../../api/my'

import { CenterWrap } from '../../components/common'
import { Sort } from '../../components/paramOption/Sort'
import { Spinner } from '../../components/spinner/Spinner'
import { InfinityScroll } from '../../components/pagingList/InfinityScroll'
import { EmptyPage } from '../../components/exception/EmptyPage'
import { ProductCard } from './components/ProductCard'

const sortList: { type: GetUserProductSoldListParams['sort']; title: string }[] = [
  { type: 'createdDate,desc', title: '최근 거래순' },
  { type: 'createdDate,asc', title: '과거 거래순' },
]

export function AssetFinish() {
  const [sort, setSort] = useState<GetUserProductSoldListParams['sort']>('createdDate,desc')

  const { data, isPending, isError, hasNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: [QUERY_KEY.productSold, { sort }],
    queryFn: async ({ pageParam = 0 }) => await getUserProductSoldList({ offset: pageParam, size: 10, sort }),
    getNextPageParam: (lastPage) => (lastPage.last ? undefined : lastPage.offset + lastPage.size),
    initialPageParam: 0,
    select: (data) => ({
      ...data,
      pages: data.pages.map((page) => page.list).flat(),
    }),
  })

  if (isPending || isError) {
    return (
      <CenterWrap>
        <Spinner />
      </CenterWrap>
    )
  }

  if (data.pages.length === 0) {
    return <EmptyPage content="조회 가능한 내역이 없습니다." />
  }

  return (
    <>
      <SortContainer>
        <Sort sortType={sort} sortList={sortList} setSortType={setSort} />
      </SortContainer>
      <InfinityScroll length={data.pages.length} isLast={!hasNextPage} next={fetchNextPage}>
        <ProductsContainer>
          {data.pages.map((product) => (
            <ProductCard key={product.id} {...product} />
          ))}
        </ProductsContainer>
      </InfinityScroll>
    </>
  )
}

const ProductsContainer = styled.article`
  display: grid;
  grid-template-columns: repeat(2, minmax(160px, 100%));
  gap: 24px 15px;
  padding: 0 16px;
`

const SortContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px;
`
